import { useMemo } from 'react';
import useEventRequiredState from '../../hooks/useEventRequiredState';
import useEventRequiredTerms from '../../hooks/useEventRequiredTermsList';
import usePreservedCallback from '@/hooks/react/usePreservedCallback';
import { TermsCategory } from '@/api/terms.types';
import Agreements from '../Agreements/Agreements';
import Submit from '../Submit/Submit';
import { useEventAvailable } from '@/queries/hooks/useEventEnter';
import useApplyEventId from '../../hooks/useApplyEventId';

const Enter = () => {
  const eventId = useApplyEventId();
  const eventAvailable = useEventAvailable(eventId);

  const data = useEventRequiredTerms();
  const [state, setState] = useEventRequiredState(data);

  const agreed = useMemo(() => Object.values(state).every(Boolean), [state]);

  const handleChangeState = usePreservedCallback(
    (category: TermsCategory, value: boolean) =>
      setState((prev) => ({ ...prev, [category]: value })),
  );

  return (
    <>
      {eventAvailable && (
        <Agreements
          data={data}
          state={state}
          onChangeState={handleChangeState}
        />
      )}
      <Submit
        agreed={agreed && eventAvailable}
        availableSubmit={eventAvailable}
      />
    </>
  );
};

export default Enter;
